import { Col, MultiColumnList, Row } from "@folio/stripes/components";
import React, { useMemo } from "react";
import { FormattedMessage, useIntl } from "react-intl";
var STATUS_LABEL_ID = {
    ADDED: "ui-br-publishers.ares.dataBoxes.status.added",
    KEPT: "ui-br-publishers.ares.dataBoxes.status.kept",
    REMOVED: "ui-br-publishers.ares.dataBoxes.status.removed",
};
var STATUS_ORDER = {
    ADDED: 0,
    KEPT: 1,
    REMOVED: 2,
};
var buildRows = function (registryBoxes, publisherDataBoxContacts) {
    var registry = registryBoxes !== null && registryBoxes !== void 0 ? registryBoxes : [];
    var registryByIsds = new Map();
    registry.forEach(function (box) {
        if (box.isds)
            registryByIsds.set(box.isds, box);
    });
    var publisherIsds = new Set(publisherDataBoxContacts.map(function (c) { return c.value; }).filter(function (v) { return !!v; }));
    var rows = [];
    registry.forEach(function (box) {
        var _a;
        if (!box.isds)
            return;
        rows.push({
            isds: box.isds,
            name: (_a = box.name) !== null && _a !== void 0 ? _a : "",
            status: publisherIsds.has(box.isds) ? "KEPT" : "ADDED",
        });
    });
    publisherDataBoxContacts.forEach(function (contact) {
        var _a;
        if (!contact.value || registryByIsds.has(contact.value))
            return;
        rows.push({
            isds: contact.value,
            name: (_a = contact.info) !== null && _a !== void 0 ? _a : "",
            status: "REMOVED",
        });
    });
    return rows.sort(function (a, b) {
        var order = STATUS_ORDER[a.status] - STATUS_ORDER[b.status];
        if (order !== 0)
            return order;
        return a.isds.localeCompare(b.isds);
    });
};
export var DataBoxesAccordion = function (_a) {
    var data = _a.data, publisher = _a.publisher;
    var formatMessage = useIntl().formatMessage;
    var dataBoxContacts = useMemo(function () {
        var _a;
        return ((_a = publisher.contacts) !== null && _a !== void 0 ? _a : []).filter(function (contact) { return contact.type === "DATA_BOX"; });
    }, [publisher.contacts]);
    var rows = useMemo(function () { return buildRows(data.dataBoxes, dataBoxContacts); }, [data.dataBoxes, dataBoxContacts]);
    if (rows.length === 0) {
        return (React.createElement(Row, null,
            React.createElement(Col, { xs: 12 },
                React.createElement("div", null,
                    React.createElement(FormattedMessage, { id: "ui-br-publishers.ares.dataBoxes.text.empty" })))));
    }
    var columnMapping = {
        isds: formatMessage({ id: "ui-br-publishers.ares.dataBoxes.column.isds" }),
        name: formatMessage({ id: "ui-br-publishers.ares.dataBoxes.column.name" }),
        status: formatMessage({
            id: "ui-br-publishers.ares.dataBoxes.column.status",
        }),
    };
    var formatter = {
        isds: function (row) { return row.isds; },
        name: function (row) { return row.name || "—"; },
        status: function (row) { return formatMessage({ id: STATUS_LABEL_ID[row.status] }); },
    };
    return (React.createElement(MultiColumnList, { contentData: rows, columnMapping: columnMapping, formatter: formatter, visibleColumns: ["isds", "name", "status"], interactive: false }));
};
